module.exports = "/shiftTasks/components/taskTemplates/templatesList/taskTemplateListItem-efd2cd.html";